import { AxiosRequestConfig } from "axios";

import { IFrameworkResource } from "../../frameworks";
import { ISkill } from "../../skills";
import { IUserResource } from "../../users";
import { createApiQueryHook, IOrderable, IPaginateable, mapOrder, mapPagination } from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IEvaluationList } from "../types/IEvaluationList";

export interface IEvaluationListQueryParameters extends IPaginateable, IOrderable<"evaluatedAt"> {
    filters?: {
        learner?: RelationalFilter<IUserResource>;
        skills?: RelationalFilter<ISkill>;
        skillsFrameworks?: RelationalFilter<IFrameworkResource>;
    };
}

export type IEvaluationListQueryResult = IEvaluationList;

const mapFilters = (filters: IEvaluationListQueryParameters["filters"]) => {
    const { learner, skills, skillsFrameworks } = filters ?? {};

    return {
        "skills.uuid": mapRelationalFilter(skills),
        "skills.frameworks.uuid": mapRelationalFilter(skillsFrameworks),
        learner: mapRelationalFilter(learner),
    };
};

export const evaluationListQuery = ({
    filters,
    pagination,
    order,
}: IEvaluationListQueryParameters): AxiosRequestConfig => {
    return {
        method: "GET",
        url: `/evaluations${serialize({
            ...mapPagination(pagination),
            ...mapOrder(order),
            ...mapFilters(filters),
        })}`,
    };
};

export const useEvaluationListQuery = createApiQueryHook<IEvaluationListQueryParameters, IEvaluationListQueryResult>(
    evaluationListQuery,
);
